import React, { useState } from 'react';

import { Button, Dropdown, Form, Segment, Modal } from 'semantic-ui-react';
import {
	Field as Fieldmik,
	Form as Formiker,
	withFormik, FieldArray
} from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import _ from 'lodash';

import MultiSelect from 'react-multi-select-component';
import { Form as FormUi } from 'semantic-ui-react';
import moment from 'moment'

import {
	customerNo, DATE_ddMMYYYY, DATE_DDMMYYYY,
	DATE_YYYYMMDD, COOKIE_USER_ID, COOKIE_USER_TOKEN, LOCAL_STORAGE
} from '../../../utils/constant.js';
import { FIELD_IS_REQUIRED, INVALID_NUMBER } from '../../../utils/validationConstant';
import { MyNormalInput } from '../../../components/dynamicComponent/myInputs';
import { AllRegex } from '../../../utils/validation';
import { DateData } from '../../../components/apiInputs/dateData';
import { EnablePerKgRateRateChart } from '../../../features/features.js';
import cogoToast from "cogo-toast";

const initSlabDetail = [{ id: 0, startSlab: '1', endSlab: '0', rate: '0' }];

const VendorBranchEdit = ({ isSubmitting, values, touched, errors,
	branchModal, CloseModal, editUserMode,
	setFieldValue, handleSubmit, props,
	isEdit, editData, state }) => {
	const [isLoading, setIsLoading] = useState(false);

	const renderView = () => {
		return (
			<Formiker>
				<div className='ui form'>
					<Segment>
						<FormUi.Group inline>
							<FormUi.Field width={2}>
								<label className='labelName'>Engine Type</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<Dropdown
									name='engineTypeId'
									style={{ width: '100%', fontWeight: 'normal' }}
									selection
									placeholder='Select Engine Type'
									value='Vendor'
									disabled
									options={
										[{ key: '2', text: 'Vendor', value: 'Vendor' }]
									}
								/>
							</FormUi.Field>
							<FormUi.Field width='2' />
							<FormUi.Field width={3}>
								<label className='labelName'>Rate Type <b className='w3-text-red'> *</b></label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<Dropdown
									name='rateTypeId'
									clearable
									style={{ width: '100%', fontWeight: 'normal' }}
									selection
									placeholder='Select Rate Type'
									value={values.rateTypeId.toString()}
									onChange={(name, data) => {
										setFieldValue('rateTypeId', data.value);
									}}
									options={
										[{ key: '1', text: 'Fix', value: '1' },
										{ key: '2', text: 'Slab', value: '2' },
										{ key: '3', text: 'Progressive', value: '3' }]
									}
								/>
								{touched.rateTypeId && errors.rateTypeId ? (
									<div className='w3-small w3-text-red'>
										{errors.rateTypeId}
									</div>
								) : null}
							</FormUi.Field>
						</FormUi.Group>

						<FormUi.Group inline>
							<FormUi.Field width={2}>
								<label className='labelName'>Expense Particular</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<Dropdown
									name="expenseParticularId"
									clearable
									style={{ width: "100%", fontWeight: "normal" }}
									selection
									placeholder="Select Expenses Particalar"
									value={values.expenseParticularId}
									options={state.lineItemList}
									onChange={(name, data) => {
										setFieldValue("expenseParticularId", data.value);
									}}
								/>
							</FormUi.Field>
							<FormUi.Field width='2' />
							<FormUi.Field width={3}>
								<label className='labelName'>Billing Party</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<MultiSelect
									className='width_adjust_100'
									name='billingPartyIds'
									clearable={false}
									ClearSelectedIcon={false}
									options={state.billingPartyList}
									value={values.billingPartyIds}
									onChange={(data) => setFieldValue('billingPartyIds', data)}
									labelledBy={'Select Billing Party'}
									overrideStrings={{
										allItemsAreSelected: 'All items are selected.',
										clearSearch: 'Clear Search',
										noOptions: 'No options',
										search: 'Search',
										selectAll: 'All',
										selectSomeItems: 'Select Billing Party',
									}}
								/>
							</FormUi.Field>
						</FormUi.Group>

						<FormUi.Group inline>
							<FormUi.Field width={2}>
								<label className='labelName'>Route</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<MultiSelect
									className='width_adjust_100'
									options={state.routeList}
									name='routeIds'
									value={values.routeIds}
									onChange={(data) => setFieldValue('routeIds', data)}
									labelledBy={'Select Route'}
									overrideStrings={{
										allItemsAreSelected: 'All items are selected.',
										clearSearch: 'Clear Search',
										noOptions: 'No options',
										search: 'Search',
										selectAll: 'All',
										selectSomeItems: 'Select Route',
									}}
								/>
							</FormUi.Field>
							<FormUi.Field width='2' />
							<FormUi.Field width={3}>
								<label className='labelName'>Vehicle Type</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<MultiSelect
									className='width_adjust_100'
									style={{ width: '100%', maxWidth: '100%', minWidth: '100%', fontWeight: '' }}
									options={state.vehicalList}
									name='vehicleTypeIds'
									value={values.vehicleTypeIds}
									onChange={(data) => setFieldValue('vehicleTypeIds', data)}
									labelledBy={'Select Vehicle type'}
									overrideStrings={{
										allItemsAreSelected: 'All items are selected.',
										clearSearch: 'Clear Search',
										noOptions: 'No options',
										search: 'Search',
										selectAll: 'All',
										selectSomeItems: 'Select Vehicle',
									}}
								/>
							</FormUi.Field>
						</FormUi.Group>

						<FormUi.Group inline>
							<FormUi.Field width={2}>
								<label className='labelName'>Consignor</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<MultiSelect
									className='width_adjust_100'
									style={{ width: '100%', maxWidth: '100%', minWidth: '100%', fontWeight: '' }}
									options={state.consignorList}
									name='consignorIds'
									value={values.consignorIds}
									onChange={(data) => setFieldValue('consignorIds', data)}
									labelledBy={'Select Consignor'}
									overrideStrings={{
										allItemsAreSelected: 'All items are selected.',
										clearSearch: 'Clear Search',
										noOptions: 'No options',
										search: 'Search',
										selectAll: 'All',
										selectSomeItems: 'Select Consignor',
									}}
								/>
							</FormUi.Field>
							<FormUi.Field width='2' />
							<FormUi.Field width={3}>
								<label className='labelName'>Consignee</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<MultiSelect
									className='width_adjust_100'
									style={{ width: '100%', maxWidth: '100%', minWidth: '100%', fontWeight: '' }}
									options={state.consigneeList}
									name='consigneeIds'
									value={values.consigneeIds}
									onChange={(data) => setFieldValue('consigneeIds', data)}
									labelledBy={'Select Consignee'}
									overrideStrings={{
										allItemsAreSelected: 'All items are selected.',
										clearSearch: 'Clear Search',
										noOptions: 'No options',
										search: 'Search',
										selectAll: 'All',
										selectSomeItems: 'Select Consignee',
									}}
								/>
							</FormUi.Field>
						</FormUi.Group>

						<FormUi.Group inline>
							<FormUi.Field width={2}>
								<label className='labelName'>Vendor</label>
							</FormUi.Field>
							<FormUi.Field width={4}>
								<Dropdown
									name='vendorIds'
									style={{ width: '100%', fontWeight: 'normal' }}
									selection
									placeholder='Select Vendor'
									value={values.vendorIds}
									disabled
									options={state.vendorList}
								/>
							</FormUi.Field>
							<FormUi.Field width='2' />
							{
								values.rateTypeId === '1' ?
									<>
										<FormUi.Field width={3}>
											<label className='labelName'>Unit of Measurement</label>
										</FormUi.Field>
										<FormUi.Field width={4} >
											<Dropdown
												name='unitOfMeasurementId'
												clearable
												style={{ width: '100%', fontWeight: 'normal' }}
												selection
												placeholder='Select Unit of Measurement'
												value={values.unitOfMeasurementId}
												options={state.unitOfMeasurementList}
												onChange={(name, data) => {
													setFieldValue('unitOfMeasurementId', data.value);
												}}
											/>
										</FormUi.Field>
									</>
									: null}
						</FormUi.Group>

						<FormUi.Group inline>
							<FormUi.Field width={2}>
								<label className='labelName'>Branch</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<MultiSelect
									className='width_adjust_100'
									style={{ width: '100%', maxWidth: '100%', minWidth: '100%', fontWeight: '' }}
									options={state.branchList}
									name='branchIds'
									value={values.branchIds}
									onChange={(data) => setFieldValue('branchIds', data)}
									labelledBy={'Select Branch'}
									overrideStrings={{
										allItemsAreSelected: 'All items are selected.',
										clearSearch: 'Clear Search',
										noOptions: 'No options',
										search: 'Search',
										selectAll: 'All',
										selectSomeItems: 'Select Branch',
									}}
								/>
							</FormUi.Field>
							<FormUi.Field width='2' />
							<FormUi.Field width={3}>
								<label className='labelName'>Load Type</label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<Dropdown
									name='loadTypeId'
									style={{ width: '100%', fontWeight: 'normal' }}
									selection
									placeholder='Select Load Type'
									value={values.loadTypeId}
									options={state.loadTypeList}
									onChange={(name, data) => {
										setFieldValue('loadTypeId', data.value);
									}}
								/>
							</FormUi.Field>
						</FormUi.Group>

						<FormUi.Group inline>
							<FormUi.Field width={2}>
								<label className='labelName'>Movement Type <b className='w3-text-red'> *</b></label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<Dropdown
									name='movementTypeId'
									style={{ width: '100%', fontWeight: 'normal' }}
									selection
									value={values.movementTypeId}
									placeholder='Select Movement Type'
									options={state.movementTypeList}
									onChange={(name, data) =>
										setFieldValue('movementTypeId', data.value)
									}
								/>
								{touched.movementTypeId && errors.movementTypeId ? (
									<div className='w3-small w3-text-red'>
										{errors.movementTypeId}
									</div>
								) : null}
							</FormUi.Field>
							<FormUi.Field width='2' />
							{
								values.movementTypeId === 1 || values.movementTypeId === 2 ? <>
									<FormUi.Field width={3}>
										<label className='labelName'>Container Type</label>
									</FormUi.Field>
									<FormUi.Field width={4} >
										<MultiSelect
											className='width_adjust_100'
											style={{ width: '100%', maxWidth: '100%', minWidth: '100%', fontWeight: '' }}
											options={state.containerTypeList}
											name='containerTypeIds'
											value={values.containerTypeIds}
											onChange={(data) => setFieldValue('containerTypeIds', data)}
											labelledBy={'Select Container Type'}
											overrideStrings={{
												allItemsAreSelected: 'All items are selected.',
												clearSearch: 'Clear Search',
												noOptions: 'No options',
												search: 'Search',
												selectAll: 'All',
												selectSomeItems: 'Select Container Type',
											}}
										/>
									</FormUi.Field>
								</> : null
							}

						</FormUi.Group>

						<FormUi.Group inline>
							<FormUi.Field width='2'>
								<label className='labelName'>Operation Type</label>
							</FormUi.Field>
							<FormUi.Field width='4'>
								<Dropdown
									name='operationTypeId'
									style={{ width: '100%', fontWeight: 'normal' }}
									selection
									placeholder='Select Operation Type'
									onChange={(name, data) =>
										setFieldValue('operationTypeId', data.value)
									}
									options={state.operationalTypeList}
									value={values.operationTypeId}
								/>
							</FormUi.Field>
							<FormUi.Field width={2} />
							<FormUi.Field width={3}>
								<label className='labelName'>Trip Type</label>
							</FormUi.Field>
							<FormUi.Field width={4}>
								<Dropdown
									name='tripTypeId'
									style={{ width: '100%', fontWeight: 'normal' }}
									selection
									placeholder='Select Trip Type'
									value={values.tripTypeId}
									options={state.tripTypeList}
									onChange={(name, data) => {
										setFieldValue('tripTypeId', data.value);
									}}
								/>
							</FormUi.Field>
						</FormUi.Group>
					</Segment>

					<Segment>
						<FormUi.Group inline>
							<FormUi.Field width={2}>
								<label className='labelName'>Start Date <b className='w3-text-red'> *</b></label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<DateData
									name='startDate'
									selectsEnd
									autoComplete='off'
									popperClassName='dateTime'
									startDate={new Date()}
									minDate={new Date()}
									style={{ width: '100%' }}
									value={values.startDate > values.endDate ? values.endDate = null : values.endDate}
									dateFormat={DATE_ddMMYYYY}
									placeholderText='Start Date'
									customInput={<Form.Input icon='time' style={{ width: '100%' }} iconPosition='left' error={touched.end_date && errors.end_date ? true : false} />}
								/>
								{touched.startDate && errors.startDate ? (
									<div className='w3-small w3-text-red'>
										{errors.startDate}
									</div>
								) : null}
							</FormUi.Field>
							<FormUi.Field width='2' />
							<FormUi.Field width={3}>
								<label className='labelName'>End Date <b className='w3-text-red'> *</b></label>
							</FormUi.Field>
							<FormUi.Field width={4} >
								<DateData
									name='endDate'
									selectsEnd
									autoComplete='off'
									popperClassName='dateTime'
									startDate={values.startDate}
									endDate={values.endDate}
									minDate={values.startDate}
									style={{ width: '100%' }}
									value={values.startDate > values.endDate ? values.endDate = null : values.endDate}
									dateFormat={DATE_ddMMYYYY}
									placeholderText='End Date'
									customInput={<Form.Input icon='time' style={{ width: '100%' }} iconPosition='left' error={touched.end_date && errors.end_date ? true : false} />}
								/>
								{touched.endDate && errors.endDate ? (
									<div className='w3-small w3-text-red'>
										{errors.endDate}
									</div>
								) : null}
							</FormUi.Field>
						</FormUi.Group>
						{
							values.rateTypeId === '1' ?
								<FormUi.Group inline>
									<FormUi.Field width={2}>
										<label className='labelName'>Amount <b className='w3-text-red'> *</b></label>
									</FormUi.Field>
									<FormUi.Field width={4} >
										<Fieldmik
											type='number'
											min='0'
											component={MyNormalInput}
											name='amount'
											placeholder='Please enter Amount'
											value={values.amount}
										/>
										{touched.amount && errors.amount ? (
											<div className='w3-small w3-text-red'>
												{errors.amount}
											</div>
										) : null}
									</FormUi.Field>
								</FormUi.Group> : null
						}
						{
							values.rateTypeId === '3' ?
								<FormUi.Group inline>
									<FormUi.Field width={2}>
										<label className='labelName'>Amount <b className='w3-text-red'> *</b></label>
									</FormUi.Field>
									<FormUi.Field width={4}>
										<Fieldmik
											type='number'
											min='0'
											component={MyNormalInput}
											name='amount'
											placeholder='Please enter Amount'
											value={values.amount}
										/>
										{touched.amount && errors.amount ? (
											<div className='w3-small w3-text-red'>
												{errors.amount}
											</div>
										) : null}
									</FormUi.Field>
									<FormUi.Field width={2} />

									<FormUi.Field width={3}>
										<label className='labelName'>Progressive Distance <b className='w3-text-red'> *</b></label>
									</FormUi.Field>
									<FormUi.Field width={4} >
										<Fieldmik
											type='number'
											min='0'
											value={values.progressiveDistance}
											component={MyNormalInput}
											name='progressiveDistance' placeholder='Progressive Distance' />
										{touched.progressiveDistance && errors.progressiveDistance ? (
											<div className='w3-small w3-text-red'>
												{errors.progressiveDistance}
											</div>
										) : null}
									</FormUi.Field>
								</FormUi.Group>
								: null
						}
						{
							values.rateTypeId === '1' && values.unitOfMeasurementId === 2 && EnablePerKgRateRateChart() ?
								<FormUi.Group inline>
									<FormUi.Field width={2}>
										<label className="labelName">Per KG Rate</label>
									</FormUi.Field>
									<FormUi.Field width={4} >
										<Fieldmik
											type='number'
											min='0'
											component={MyNormalInput}
											name="perKgRate"
											placeholder='Enter Per KG Rate'
											value={values.perKgRate}
										/>
										{touched.perKgRate && errors.perKgRate ? (
											<div className="w3-small w3-text-red">
												{errors.perKgRate}
											</div>
										) : null}
									</FormUi.Field>
								</FormUi.Group>
								: null
						}

						{
							values.rateTypeId === '2' ?
								<>
									<FormUi.Group inline>
										<FormUi.Field width={2}>
											<label className='labelName'>Fixed Slab Rate <b className='w3-text-red'> *</b></label>
										</FormUi.Field>
										<FormUi.Field width={4} >
											<Fieldmik
												type='number'
												min='0'
												component={MyNormalInput}
												name='fixedSlabRate'
												placeholder='Enter Fixed slab rate'
												value={values.fixedSlabRate}
											/>
											{touched.fixedSlabRate && errors.fixedSlabRate ? (
												<div className='w3-small w3-text-red'>
													{errors.fixedSlabRate}
												</div>
											) : null}
										</FormUi.Field>
									</FormUi.Group>
									<FieldArray
										name='slabDetails'
										width={12}
										render={(arrayHelpers) => {
											return (
												<>
													<table className='table'>
														<thead className='thead-light'>
															<tr>
																<th style={{ width: '25%' }} scope='col'>Start (In KM)</th>
																<th style={{ width: '25%' }} scope='col'>End (In KM)</th>
																<th style={{ width: '25%' }} scope='col'>Price</th>
															</tr>
														</thead>
														<tbody>
															{(values?.slabDetails.length ? values?.slabDetails : initSlabDetail).map((item, index) => {
																const arr = values?.slabDetails.length ? values?.slabDetails : initSlabDetail;
																return (
																	<>
																		<tr key={index} style={{ width: '100%' }}>
																			<td style={{ width: '33.33%' }} >
																				<FormUi.Field >
																					<Fieldmik component={MyNormalInput}
																						type='number'
																						min='0'
																						name={`${arr[index].startSlab}`} readOnly
																						placeholder='Start KM' value={item.startSlab}
																					/>
																				</FormUi.Field>
																			</td>
																			<td style={{ width: '33.33%' }}>
																				<FormUi.Field >
																					<Fieldmik component={MyNormalInput}
																						type='number'
																						min='0'
																						name={`slabDetails[${index}].endSlab`}
																						value={arr[index].endSlab}
																						placeholder='Please enter End KM'
																						onChange={(e) => {
																							setFieldValue(`slabDetails[${index}].endSlab`, e.target.value)
																							if (arr.length > index + 1) {
																								setFieldValue(`slabDetails[${index + 1}].startSlab`, +e.target.value + 1)
																							}
																							if (!arr[0].startSlab) {
																								setFieldValue(`slabDetails[${0}].startSlab`, 1)
																							}
																						}}
																					/>
																				</FormUi.Field>
																			</td>
																			<td style={{ width: '33.33%' }}>
																				<FormUi.Field >
																					<Fieldmik component={MyNormalInput}
																						type='number'
																						min='0'
																						name={`slabDetails[${index}].rate`}
																						value={arr[index].rate}
																						placeholder='Please enter freight rate'
																					/>
																				</FormUi.Field>
																			</td>
																		</tr>
																	</>
																)
															})}
														</tbody>
													</table>
													<Button
														basic
														color='blue'
														className='m-2'
														type='button'
														size='mini'
														onClick={() =>
															arrayHelpers.push({ id: values.slabDetails.length, startSlab: Number(values.slabDetails[values.slabDetails.length - 1]?.endSlab) + 1 || '1', endSlab: '', rate: '' })
														}>
														+ Add More Slab
													</Button>
												</>)
										}}
									/>
								</> : null
						}
					</Segment>

					{
						values.movementTypeId === 5 ?
							<Segment>
								<FormUi.Group inline>
									<FormUi.Field width={2}>
										<label className='labelName'>Per KM Rate</label>
									</FormUi.Field>
									<FormUi.Field width={4} >
										<Fieldmik
											type='number'
											min='0'
											component={MyNormalInput}
											name='perKmRate'
											value={values.perKmRate}
											placeholder='Enter per KM rate'
										/>
										{touched.perKmRate && errors.perKmRate ? (
											<div className='w3-small w3-text-red'>
												{errors.perKmRate}
											</div>
										) : null}
									</FormUi.Field>
									<FormUi.Field width='2' />
									<FormUi.Field width={2}>
										<label className='labelName'>TAT Allowance per day</label>
									</FormUi.Field>
									<FormUi.Field width={4}>
										<Dropdown
											name='dayAllowance'
											style={{ width: '100%', fontWeight: 'normal' }}
											selection
											placeholder='TAT Allowance per day'
											value={values.dayAllowance}
											options={
												[{ key: '12.00', text: '12.00', value: '12.00' },
												{ key: '24.00', text: '24.00', value: '24.00' }]
											}
											onChange={(name, data) => {
												setFieldValue('dayAllowance', data.value);
											}}
										/>
									</FormUi.Field>
								</FormUi.Group>
								<FormUi.Group inline>
									<FormUi.Field width={2}>
										<label className='labelName'>Per Hour Rate</label>
									</FormUi.Field>
									<FormUi.Field width={4} >
										<Fieldmik
											type='number'
											min='0'
											name='perHourRate'
											placeholder='Please Enter Per Hour Rate'
											component={MyNormalInput}
											value={values.perHourRate}
										/>
										{touched.perHourRate && errors.perHourRate ? (
											<div className='w3-small w3-text-red'>
												{errors.perHourRate}
											</div>
										) : null}
									</FormUi.Field>
									<FormUi.Field width='2' />
								</FormUi.Group>
							</Segment>
							: null
					}
				</div>
			</Formiker>
		)
	};

	return (
		<Modal open={branchModal} onClose={CloseModal} size='large'>
			<Modal.Header closeButton>
				{editData ? 'Edit Rate Chart' : 'Add Rate Chart'}
			</Modal.Header>
			<Modal.Content>
				{
					isLoading ? <h4>Loading</h4> : renderView()
				}
			</Modal.Content>
			<Modal.Actions>
				<Button className='w3-green' type='button' onClick={CloseModal}>
					Cancel
				</Button>
				<Button type='submit' className='w3-blue' onClick={handleSubmit}>
					Ok
				</Button>
			</Modal.Actions>
		</Modal>
	)
};

const RatechartModal = withFormik({
	enableReinitialize: true,
	mapPropsToValues: (props) => {
		const editData = props.editData;
		const { consigneeList, billingPartyList, routeList,
			vehicalList, consignorList, vendorList,
			branchList, containerTypeList } = props.state;
		const tempData = {
			engineTypeId: editData?.engineTypeId.toString() || '2',
			rateTypeId: editData?.rateTypeId.toString() || '',
			fixedSlabRate: editData?.fixedSlabRate.toString() || null,
			expenseParticularId: editData?.expenseParticularId || '',

			isBillingPartyAll: '1',
			billingPartyIds: billingPartyList,

			isRouteAll: editData?.isRouteAll == '1' ? '1' : '0',
			routeIds: editData?.isRouteAll == 1 ? routeList : editData ? [editData?.routeIds[0]['0']] : [],

			isVehicleTypeAll: editData?.isVehicleTypeAll == '1' ? '1' : '0',
			vehicleTypeIds: editData?.isVehicleTypeAll == '1' ? vehicalList : editData ? [editData?.vehicleTypeIds[0]['0']] : [],

			isConsignorAll: editData?.isConsignorAll == '1' ? '1' : '0',
			consignorIds: editData?.isConsignorAll == '1' ? consignorList : editData ? [editData?.consignorIds[0]['0']] : [],

			isConsigneeAll: editData?.isConsigneeAll == '1' ? '1' : '0',
			consigneeIds: editData?.isConsigneeAll == 1 ? consigneeList : editData ? [editData?.consigneeIds[0]['0']] : [],

			isContainerTypeAll: editData?.containerTypeIds == '1' ? '1' : '0',
			containerTypeIds: editData?.isContainerTypeAll == 1 ? containerTypeList : editData ? [editData?.containerTypeIds[0]['0']] : [],

			isVendorAll: editData?.isVendorAll == '1' ? '1' : '0',
			vendorIds: vendorList[0].value.toString(),

			isBranchAll: '1',
			branchIds: branchList,

			unitOfMeasurementId: editData?.unitOfMeasurementId || '0',
			amount: editData?.amount.toString() || null,

			startDate: editData?.startDate ? moment(editData?.startDate, DATE_DDMMYYYY) : null,
			endDate: editData?.endDate ? moment(editData?.endDate, DATE_DDMMYYYY) : null,
			progressiveDistance: editData?.progressiveDistance.toString() || '0',
			uomCost: editData?.uomCost.toString() || '0',
			startSlab: editData?.startSlab || '0',
			endSlab: editData?.endSlab || '0',
			operationTypeId: editData?.operationTypeId || 1,
			tripTypeId: editData?.tripTypeId || 2,
			loadTypeId: editData?.loadTypeId || 4,
			minTemp: editData?.minTemp.toString() || '0',
			maxTemp: editData?.maxTemp.toString() || '0',
			movementTypeId: editData?.movementTypeId || 5,
			loadingPatternId: editData?.loadingPatternId.toString() || '0',
			startWeightSlab: editData?.startWeightSlab.toString() || '0',
			endWeightSlab: editData?.endWeightSlab.toString() || '0',

			customerNo: LOCAL_STORAGE.customerNo,
			userId: LOCAL_STORAGE.userId,
			perKgRate: editData?.perKgRate?.toString() || '0',
			slabDetails: editData && editData?.slabDetails[0] !== null ? editData?.slabDetails.map(item => { return Object.values(item) })[0] : initSlabDetail,
			perKmRate: editData?.perKmRate.toString() || '0',
			dayAllowance: editData?.dayAllowance || '12.00',
			perHourRate: editData?.perHourRate.toString() || '0',
		}
		return tempData;
	},
	validationSchema: yup.object({
		rateTypeId: yup.mixed().required(FIELD_IS_REQUIRED),
		startDate: yup.string().required(FIELD_IS_REQUIRED).nullable(),
		endDate: yup.string().required(FIELD_IS_REQUIRED).nullable(),
		movementTypeId: yup.string().required(FIELD_IS_REQUIRED),
		fixedSlabRate: yup.string().when('rateTypeId', {
			is: (rateTypeId) => {
				return rateTypeId === '2' ? true : false
			},
			then: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.PositiveNumberWithPoint, INVALID_NUMBER).nullable(),
			otherwise: yup.string().optional().nullable(),
		}),
		progressiveDistance: yup.string().when('rateTypeId', {
			is: (rateTypeId) => {
				return rateTypeId === '3' ? true : false
			},
			then: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.PositiveNumberWithPoint, INVALID_NUMBER).nullable(),
			otherwise: yup.string().optional().nullable(),
		}),
		amount: yup.string().when('rateTypeId', {
			is: (rateTypeId) => {
				return rateTypeId === '3' || rateTypeId === '1' ? true : false
			},
			then: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.PositiveNumberWithPoint, INVALID_NUMBER).nullable(),
			otherwise: yup.string().optional().nullable(),
		}),
		perKgRate: yup.string().optional().matches(AllRegex.PositiveNumberWithPoint, INVALID_NUMBER).nullable(),
		perKmRate: yup.string().optional().matches(AllRegex.PositiveNumberWithPoint, INVALID_NUMBER).nullable(),
		perHourRate: yup.string().optional().matches(AllRegex.PositiveNumberWithPoint, INVALID_NUMBER).nullable(),
	}),
	handleSubmit(values, { props }) {
		const { consigneeListLength, billingPartyListLength, routeListLength,
			vehicalListLength, consignorListLength, vendorListLength,
			branchListLength, containerTypeListLength } = props.lengthArray;
		const { vendorList } = props.state;
		const apiData = {
			engineTypeId: values.engineTypeId,
			rateTypeId: values.rateTypeId || '0',
			expenseParticularId: values.expenseParticularId.toString() || '0',

			isBillingPartyAll: billingPartyListLength === values.billingPartyIds.length || !values.billingPartyIds.length ? '1' : '0',
			billingPartyIds: billingPartyListLength === values.billingPartyIds.length ? '0' : values.billingPartyIds.length ? _.join(values.billingPartyIds.map(function (a) { return a.key.toString() }), ',') : '0',

			isRouteAll: routeListLength === values.routeIds.length || !values.routeIds.length ? '1' : '0',
			routeIds: routeListLength === values.routeIds.length ? '0' : values.routeIds.length ? _.join(values.routeIds.map(function (a) { return a.key.toString() }), ',') : '0',

			isVehicleTypeAll: vehicalListLength === values.vehicleTypeIds.length || !values.vehicleTypeIds.length ? '1' : '0',
			vehicleTypeIds: vehicalListLength === values.vehicleTypeIds.length ? '0' : values.vehicleTypeIds.length ? _.join(values.vehicleTypeIds.map(function (a) { return a.key.toString() }), ',') : '0',

			isConsignorAll: consignorListLength === values.consignorIds.length || !values.consignorIds.length ? '1' : '0',
			consignorIds: consignorListLength === values.consignorIds.length ? '0' : values.consignorIds.length ? _.join(values.consignorIds.map(function (a) { return a.key.toString() }), ',') : '0',

			isConsigneeAll: consigneeListLength === values.consigneeIds.length || !values.consigneeIds.length ? '1' : '0',
			consigneeIds: consigneeListLength === values.consigneeIds.length ? '0' : values.consigneeIds.length ? _.join(values.consigneeIds.map(function (a) { return a.key.toString() }), ',') : '0',

			isVendorAll: vendorListLength === values.vendorIds.length || !values.vendorIds.length ? '1' : '0',
			vendorIds: vendorList[0].value.toString(),

			isBranchAll: branchListLength === values.branchIds.length || !values.branchIds.length ? '1' : '0',
			branchIds: branchListLength === values.branchIds.length ? '0' : values.branchIds.length ? _.join(values.branchIds.map(function (a) { return a.key.toString() }), ',') : '0',

			isContainerTypeAll: containerTypeListLength === values.containerTypeIds.length || !values.containerTypeIds.length ? '1' : '0',
			containerTypeIds: containerTypeListLength === values.containerTypeIds.length ? '0' : values.containerTypeIds.length ? _.join(values.containerTypeIds.map(function (a) { return a.key.toString() }), ',') : '0',

			unitOfMeasurementId: values.unitOfMeasurementId || '0',
			amount: values.amount || '0',
			startDate: moment(values.startDate).format(DATE_YYYYMMDD) || '0',
			endDate: moment(values.endDate).format(DATE_YYYYMMDD) || '0',
			progressiveDistance: values.progressiveDistance || '0',
			uomCost: values.uomCost || '0',
			startSlab: values.startSlab || '0',
			endSlab: values.endSlab || '0',
			fixedSlabRate: values.fixedSlabRate || '0',
			operationTypeId: values.operationTypeId || '0',
			tripTypeId: values.tripTypeId || '0',
			loadTypeId: values.loadTypeId || '0',
			minTemp: values.minTemp || '0',
			maxTemp: values.maxTemp || '0',
			movementTypeId: values.movementTypeId || '0',
			loadingPatternId: values.loadingPatternId || '0',
			startWeightSlab: values.startWeightSlab || '0',
			endWeightSlab: values.endWeightSlab || '0',
			customerNo: customerNo,
			userId: COOKIE_USER_ID,

			slabDetails: values.slabDetails === initSlabDetail || values.slabDetails[0] === null ? '0' : values.slabDetails,
			isMultipleSlab: (values.slabDetails === initSlabDetail || values.slabDetails[0] === null) && (values.slabDetails[0].endSlab === null || Number(values?.slabDetails[0]?.endSlab) === 0) ? '0' : '1',

			perKmRate: values.perKmRate || '0',
			perKgRate: values?.perKgRate?.toString() || '0',
			dayAllowance: values.dayAllowance || '0',
			perHourRate: values.perHourRate || '0',
			rateEngineId: props?.editData?.rateEngineId || '0'
		};
		if (props?.isEdit && props?.editData) {
			axios.patch(`${process.env.REACT_APP_BASE_COMMON}/masters/rateEngine/update`, apiData, {
				headers: { 'content-type': 'application/json', 'Authorization': `${COOKIE_USER_TOKEN}` }
			})
				.then(response => {
					if (response.status === 200) {
						if (response.data.status === 204) {
							props.clearData();
							cogoToast.error(response.data.message);
						}
						else {
							cogoToast.success('Rate chart Updated');
							setTimeout(() => {
								props.CloseModal();
								window.location.reload();
							}, 1000);
						}

					}
				})
				.catch(err => console.log("error", err));
		}
		else {
			axios.put(`${process.env.REACT_APP_BASE_COMMON}/masters/rateEngine/`, apiData, {
				headers: { 'content-type': 'application/json', 'Authorization': `${COOKIE_USER_TOKEN}` }
			})
				.then(response => {
					if (response.status === 200) {
						if (response.data.status === 204) {
							props.clearData();
							cogoToast.error(response.data.message);
						}
						else {
							cogoToast.success('Rate chart Created');
							setTimeout(() => {
								props.CloseModal();
								window.location.reload();
							}, 1000);
						}
					}
				})
				.catch(err => console.log("error", err));
		}
	}
})(VendorBranchEdit);
export default RatechartModal;
